var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcLiveOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E4EFF0",
  fillRule: "evenodd",
  d: "m1.211 13.79-1.15 4.12a1.647 1.647 0 0 0 2.03 2.03s2.62-.73 4.05-1.12c.48-.13.98-.13 1.46.02.88.27 1.82.41 2.78.41 5.3 0 9.61-4.31 9.61-9.63S15.691 0 10.391 0s-9.6 4.31-9.6 9.63c0 .95.14 1.86.4 2.72.14.47.15.97.02 1.45z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#B6D0D2",
  d: "M15.02 6.34a.51.51 0 0 0-.52.01l-1.43.9c.04.18.07.37.07.56v3.64c0 .19-.02.37-.06.55l1.43.89c.08.05.18.08.27.08.08 0 .17-.02.25-.06.16-.09.26-.26.26-.45V6.79c0-.19-.1-.36-.26-.45zM10.91 6.34H6.82a1.47 1.47 0 0 0-1.47 1.47v3.65c0 .812.658 1.47 1.47 1.47h4.09a1.47 1.47 0 0 0 1.47-1.47V7.81a1.47 1.47 0 0 0-1.47-1.47"
})));
export default SvgIcLiveOff;